import cx from 'classnames';
import PropTypes from 'prop-types';
import { useState, useReducer, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DragDropProvider } from '@dnd-kit/react';
import DTAutoSuggest from '@digitransit-component/digitransit-component-autosuggest';
import Icon, { defaultColors } from '@digitransit-component/digitransit-component-icon';
import isEmpty from 'lodash/isEmpty';
import { useSelect } from 'downshift';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useSortable } from '@dnd-kit/react/sortable';
import { createInstance } from 'i18next';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".select_combobox-container__l-gXK {\n  background-color: #fff;\n  border: solid #888 1px;\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  height: 50px;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n.select_combobox-container__l-gXK:focus-within {\n  border-color: #007ac9;\n}\n.select_combobox-container__l-gXK .select_left-column__NCDpJ {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.select_combobox-label__QYe0V {\n  font-size: 12px;\n  line-height: 20px;\n  color: #666;\n  letter-spacing: -0.48px;\n  margin-left: 12px;\n  margin-top: 4px;\n}\n\n.select_container__U5yMR {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.select_container__U5yMR > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n.select_container__U5yMR .select_suggestion__7in7q {\n  font-size: 15px;\n  line-height: 49px;\n  height: 50px;\n  padding: 0 0 0 12px;\n  letter-spacing: -0.6px;\n  color: #333;\n  font-weight: 500;\n}\n.select_container__U5yMR .select_suggestionHighlighted__HV-5T {\n  font-size: 15px;\n  font-weight: 500;\n  background: #f2f5f7;\n}\n.select_container__U5yMR .select_suggestionsContainerOpen__SzPE6 {\n  position: absolute;\n  background-color: #fff;\n  z-index: 20;\n  max-height: 250px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  border-radius: 5px;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.06);\n  border: 1px rgba(0, 0, 0, 0.1) solid;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.select_container__U5yMR .select_suggestionsContainerOpen__SzPE6 ul {\n  padding: 0;\n  margin: 0;\n}\n.select_container__U5yMR .select_suggestionsContainerOpen__SzPE6 li:not(:last-child) {\n  border-bottom: 1px solid #ddd;\n}\n.select_container__U5yMR .select_input__tiwn5 {\n  -webkit-appearance: none;\n          appearance: none;\n  margin: -4px 0 0 0;\n  padding-left: 12px;\n  border: none;\n  height: 26px;\n}\n.select_container__U5yMR .select_input__tiwn5:focus {\n  outline: none;\n  border: none;\n  box-shadow: none;\n  background: #fff;\n}\n.select_container__U5yMR .select_input__tiwn5:read-only {\n  cursor: pointer;\n  background: #fff;\n}\n.select_container__U5yMR .select_input__tiwn5 {\n  background: #fff;\n  font-weight: 500;\n  box-shadow: none;\n  font-size: 15px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.33;\n  letter-spacing: -0.6px;\n  color: #333;\n}";
var styles$1 = {"combobox-container":"select_combobox-container__l-gXK","left-column":"select_left-column__NCDpJ","combobox-label":"select_combobox-label__QYe0V","container":"select_container__U5yMR","suggestion":"select_suggestion__7in7q","suggestionHighlighted":"select_suggestionHighlighted__HV-5T","suggestionsContainerOpen":"select_suggestionsContainerOpen__SzPE6","input":"select_input__tiwn5"};
styleInject(css_248z$1);

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Select = ({
  value,
  options,
  onSlackTimeSelected,
  viaPointIndex,
  id,
  label,
  icon
}) => {
  const labelId = `${id}-label`;
  const selectedItem = options.find(option => option.value === value);
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    getLabelProps,
    highlightedIndex
  } = useSelect({
    selectedItem,
    items: options,
    labelId,
    id,
    itemToString: item => item.displayName,
    onSelectedItemChange: ({
      selectedItem: newItem
    }) => {
      onSlackTimeSelected(newItem.value, viaPointIndex);
    }
  });
  return /*#__PURE__*/jsx("div", {
    className: styles$1['combobox-container'],
    children: /*#__PURE__*/jsxs("div", {
      className: styles$1.container,
      children: [/*#__PURE__*/jsxs("div", _objectSpread$1(_objectSpread$1({}, getToggleButtonProps()), {}, {
        children: [/*#__PURE__*/jsxs("span", {
          className: styles$1['left-column'],
          children: [/*#__PURE__*/jsx("label", _objectSpread$1(_objectSpread$1({}, getLabelProps()), {}, {
            className: styles$1['combobox-label'],
            children: label
          })), /*#__PURE__*/jsx("div", {
            className: styles$1.input,
            children: /*#__PURE__*/jsx("span", {
              children: selectedItem.displayName
            })
          })]
        }), icon]
      })), /*#__PURE__*/jsx("ul", _objectSpread$1(_objectSpread$1({
        className: cx(styles$1.suggestionsContainerOpen, !isOpen && 'hidden')
      }, getMenuProps()), {}, {
        children: isOpen && options.map((option, index) => /*#__PURE__*/jsx("li", _objectSpread$1(_objectSpread$1({
          className: cx(styles$1.suggestion, index === highlightedIndex && styles$1.suggestionHighlighted)
        }, getItemProps({
          index
        })), {}, {
          children: /*#__PURE__*/jsx("span", {
            children: option.displayName
          })
        }), option.value))
      }))]
    })
  });
};
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  value: PropTypes.number.isRequired,
  onSlackTimeSelected: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }).isRequired).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
  viaPointIndex: PropTypes.number.isRequired
} : void 0;

function SortableViaPoint({
  id,
  index,
  disabled,
  className,
  children
}) {
  const {
    ref,
    handleRef
  } = useSortable({
    id,
    index,
    disabled
  });
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: className,
    children: children(handleRef)
  });
}
process.env.NODE_ENV !== "production" ? SortableViaPoint.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired
} : void 0;

const translations = {
  de: {
    translation: {
      'add-via-button-label': 'Füge Zwischenziel hinzu',
      'add-via-duration-button-label': 'Setze Umsteigezeit für Zwischenziel {{index}}',
      'add-via-duration-button-label-close': 'Schließe Umsteigezeit-Auswahl für Zwischenziel {{index}}',
      'add-via-duration-button-label-open': 'Öffne Umsteigezeit-Auswahl für Zwischenziel {{index}}',
      'minute-short': 'min',
      'remove-via-button-label': 'Entferne Zwischenziel {{index}}',
      'swap-order-button-label': 'Tausche Start mit Ziel',
      'via-point': 'Zwischenziel',
      'via-point-index': 'Zwischenziel {{index}}',
      'viapoint-slack-amount': 'Umsteigezeit'
    }
  },
  en: {
    translation: {
      'add-via-button-label': 'Add via point',
      'add-via-duration-button-label': 'Set stop duration at via point {{index}}',
      'add-via-duration-button-label-close': 'Close stop duration selector at via point {{index}}',
      'add-via-duration-button-label-open': 'Open stop duration selector at via point {{index}}',
      'minute-short': 'min',
      'remove-via-button-label': 'Remove via point {{index}}',
      'swap-order-button-label': 'Reverse origin and destination',
      'via-point': 'Via point',
      'via-point-index': 'Via point {{index}}',
      'viapoint-slack-amount': 'Stop duration'
    }
  },
  fi: {
    translation: {
      'add-via-button-label': 'Lisää välipiste',
      'add-via-duration-button-label': 'Aseta välipisteelle {{index}} pysähdyksen kesto',
      'add-via-duration-button-label-close': 'Avaa välipisteen {{index}} pysähdyksen kesto valitsin',
      'add-via-duration-button-label-open': 'Sulje välipisteen {{index}} pysähdyksen kesto valitsin',
      'minute-short': 'min',
      'remove-via-button-label': 'Poista välipiste {{index}}',
      'swap-order-button-label': 'Käännä reitin suunta vastakkaiseksi',
      'via-point': 'Välipiste',
      'via-point-index': 'Välipiste {{index}}',
      'viapoint-slack-amount': 'Pysähdyksen kesto'
    }
  },
  pl: {
    translation: {
      'add-via-button-label': 'Dodaj punkt pośredni',
      'add-via-duration-button-label': 'Wybierz czas postoju dla punktu {{index}}',
      'add-via-duration-button-label-close': 'Zamknij wybornik czasu postoju w punkcie {{index}}',
      'add-via-duration-button-label-open': 'Otwórz wybornik czasu postoju w punkcie {{index}}',
      'minute-short': 'min.',
      'remove-via-button-label': 'Usuń punkt pośredni {{index}}',
      'swap-order-button-label': 'Odwróć początek i cel',
      'via-point': 'Punkt pośredni',
      'via-point-index': 'Punkt pośredni {{index}}',
      'viapoint-slack-amount': 'Czas postoju'
    }
  },
  sv: {
    translation: {
      'add-via-button-label': 'Lägg till viapunkt',
      'add-via-duration-button-label': 'Ställ in varaktighet för viapunkten {{index}}',
      'add-via-duration-button-label-close': 'Stäng väljaren för varaktighet vid via-punkten {{index}}',
      'add-via-duration-button-label-open': 'Öppna väljaren för varaktighet vid via-punkten {{index}}',
      'minute-short': 'min',
      'remove-via-button-label': 'Ta bort viapunkt {{index}}',
      'swap-order-button-label': 'Sväng ruttens riktning till den motsatta',
      'via-point': 'Via punkt',
      'via-point-index': 'Via punkt {{index}}',
      'viapoint-slack-amount': 'Stoppets varaktighet'
    }
  }
};

const i18n = createInstance({
  fallbackLng: 'fi',
  // debug: true,
  resources: translations,
  defaultNS: 'translation',
  react: {
    useSuspense: true
  }
});
i18n.init();

var css_248z = ".styles_autosuggest-panel__GEaoJ {\n  width: 100%;\n}\n\n.styles_autosuggest-searchpanel-text__7O850 {\n  font-size: 24px;\n  font-weight: var(--font-weight-medium, 500);\n  letter-spacing: -0.8px;\n  color: #333;\n  line-height: 1;\n  margin-bottom: 17px;\n  margin-top: unset;\n}\n@media screen and (min-width: 768px) {\n  .styles_autosuggest-searchpanel-text__7O850 {\n    letter-spacing: -0.8px;\n    line-height: 27px;\n    margin-bottom: 21px;\n  }\n}\n\n.styles_origin-input-container__yfozN,\n.styles_destination-input-container__kJPky {\n  display: flex;\n  flex: 1 0 100%;\n}\n.styles_origin-input-container__yfozN input[type=text],\n.styles_destination-input-container__kJPky input[type=text] {\n  margin: 0;\n}\n\n.styles_row__MvzsR {\n  display: flex;\n  flex-direction: row;\n}\n\n.styles_viapoints-container__fukkW {\n  display: flex;\n  flex-direction: column;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE {\n  display: flex;\n  flex: 1 0 100%;\n  min-height: 50px;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE:first-child {\n  margin-top: 6px;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE:not(:first-child) {\n  margin-top: 3px;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE:last-child {\n  margin-bottom: 6px;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM {\n  display: flex;\n  padding: 3px 0;\n  flex-direction: column;\n  background: #f2f5f7;\n  border-radius: 5px;\n  width: 100%;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-before__J1O3f {\n  display: flex;\n  min-width: 27px;\n  justify-content: center;\n  align-items: center;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-before__J1O3f svg {\n  fill: #888;\n  height: 20px;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9 input[type=text] {\n  margin: 0;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9.styles_viapoint-1__s2wSB > div.styles_viapoint__UnOwm {\n  z-index: 15;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9.styles_viapoint-2__JNsq8 > div.styles_viapoint__UnOwm {\n  z-index: 14;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9.styles_viapoint-3__tv7Qy > div.styles_viapoint__UnOwm {\n  z-index: 13;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9.styles_viapoint-4__v0tfs > div.styles_viapoint__UnOwm {\n  z-index: 12;\n}\n.styles_viapoints-container__fukkW .styles_viapoint-container__O-xAE .styles_light-gray-background__0vkzM .styles_viapoint-input-container__fEQi9.styles_viapoint-5__luT-- > div.styles_viapoint__UnOwm {\n  z-index: 11;\n}\n\n.styles_viapoint-slack-time__dV527 {\n  font-size: 13px;\n  font-weight: normal;\n  letter-spacing: -0.36px;\n  color: #333;\n  padding-left: 27px;\n  padding-top: 12px;\n  padding-bottom: 10px;\n}\n\n.styles_select-wrapper__zaWty {\n  display: flex;\n  height: 50px;\n  margin-top: 9px;\n  padding-left: 27px;\n  padding-right: 47px;\n}\n\n.styles_via-point-button-container__kUBm7 {\n  display: flex;\n}\n.styles_via-point-button-container__kUBm7 > div:nth-child(1) {\n  order: 1;\n  border-left: none;\n}\n.styles_via-point-button-container__kUBm7 > div:nth-child(2) {\n  order: 2;\n  border-left: 1px solid rgba(151, 151, 151, 0.2);\n}\n\n.styles_input-viapoint-slack-container__-LDqu {\n  display: flex;\n  flex-direction: column;\n}\n\n.styles_itinerary-search-control__1KyCb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  max-height: 50px;\n  min-width: var(--width);\n}\n.styles_itinerary-search-control__1KyCb + .styles_itinerary-search-control__1KyCb {\n  border-left: 1px solid rgba(151, 151, 151, 0.2);\n}\n.styles_itinerary-search-control__1KyCb .styles_opposite__BE7K1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: 40px;\n  cursor: pointer;\n}\n.styles_itinerary-search-control__1KyCb .styles_opposite__BE7K1 svg {\n  width: 19px;\n  height: 17px;\n}\n.styles_itinerary-search-control__1KyCb .styles_add-via-point__7E6zU {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: 40px;\n  cursor: pointer;\n}\n.styles_itinerary-search-control__1KyCb .styles_add-via-point__7E6zU svg {\n  width: 20px;\n  height: 22px;\n}\n.styles_itinerary-search-control__1KyCb .styles_add-via-point-slack__kddhr {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: 47px;\n  cursor: pointer;\n}\n.styles_itinerary-search-control__1KyCb .styles_add-via-point-slack__kddhr svg {\n  width: 18px;\n  height: 19px;\n}\n.styles_itinerary-search-control__1KyCb .styles_remove-via-point__1oWx- {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  max-height: 44px;\n  min-width: 40px;\n  cursor: pointer;\n}\n.styles_itinerary-search-control__1KyCb .styles_remove-via-point__1oWx- svg {\n  width: 14px;\n  height: 14px;\n}\n\n.styles_combobox-icon__fhYvA {\n  color: var(--color);\n  border-left: solid #888 1px;\n  height: 35px;\n}\n.styles_combobox-icon__fhYvA.styles_time-input-icon__L2TcV {\n  padding: 9px 13px 0 13px;\n}\n.styles_combobox-icon__fhYvA.styles_time-input-icon__L2TcV svg {\n  width: 18px;\n  height: 19px;\n}\n\n.styles_rectangle-container__4Vtuo {\n  display: block;\n  position: relative;\n  height: 9px;\n  z-index: 19;\n}\n.styles_rectangle-container__4Vtuo .styles_rectangle__s-y7y {\n  position: absolute;\n  width: 4px;\n  height: 25px;\n  border-radius: 2px;\n  background-color: #ddd;\n  margin-left: 25px;\n  margin-top: -9px;\n}\n\n.styles_search-panel-whitespace__RefGL {\n  min-width: 40px;\n}";
var styles = {"autosuggest-panel":"styles_autosuggest-panel__GEaoJ","autosuggest-searchpanel-text":"styles_autosuggest-searchpanel-text__7O850","origin-input-container":"styles_origin-input-container__yfozN","destination-input-container":"styles_destination-input-container__kJPky","row":"styles_row__MvzsR","viapoints-container":"styles_viapoints-container__fukkW","viapoint-container":"styles_viapoint-container__O-xAE","light-gray-background":"styles_light-gray-background__0vkzM","viapoint-before":"styles_viapoint-before__J1O3f","viapoint-input-container":"styles_viapoint-input-container__fEQi9","viapoint-1":"styles_viapoint-1__s2wSB","viapoint":"styles_viapoint__UnOwm","viapoint-2":"styles_viapoint-2__JNsq8","viapoint-3":"styles_viapoint-3__tv7Qy","viapoint-4":"styles_viapoint-4__v0tfs","viapoint-5":"styles_viapoint-5__luT--","viapoint-slack-time":"styles_viapoint-slack-time__dV527","select-wrapper":"styles_select-wrapper__zaWty","via-point-button-container":"styles_via-point-button-container__kUBm7","input-viapoint-slack-container":"styles_input-viapoint-slack-container__-LDqu","itinerary-search-control":"styles_itinerary-search-control__1KyCb","opposite":"styles_opposite__BE7K1","add-via-point":"styles_add-via-point__7E6zU","add-via-point-slack":"styles_add-via-point-slack__kddhr","remove-via-point":"styles_remove-via-point__1oWx-","combobox-icon":"styles_combobox-icon__fhYvA","time-input-icon":"styles_time-input-icon__L2TcV","rectangle-container":"styles_rectangle-container__4Vtuo","rectangle":"styles_rectangle__s-y7y","search-panel-whitespace":"styles_search-panel-whitespace__RefGL"};
styleInject(css_248z);

const _excluded = ["children", "className", "enabled", "onClick", "onKeyPress", "wide"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getEmptyViaPointPlaceHolder = () => ({});
const isViaPointEmpty = viaPoint => {
  if (viaPoint === undefined || isEmpty(viaPoint)) {
    return true;
  }
  const keys = Object.keys(viaPoint);
  return keys.length === 1 || keys.length === 2 && keys.includes('locationSlack');
};
const ItinerarySearchControl = _ref => {
  let {
      children,
      className,
      enabled,
      onClick,
      onKeyPress,
      wide = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx("div", {
    className: styles['itinerary-search-control'],
    style: {
      '--width': wide ? '47px' : '40px'
    },
    children: onClick && enabled && /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
      className: className,
      onClick: onClick,
      onKeyPress: onKeyPress,
      role: "button",
      tabIndex: "0",
      children: children
    }))
  });
};
const updateViaPointSlack = (activeViaPointSlacks, updatedViaPointIndex, viaPointRemoved = false) => {
  const remaining = activeViaPointSlacks.filter(index => index !== updatedViaPointIndex);
  return viaPointRemoved ? remaining.map(index => index > updatedViaPointIndex ? index - 1 : index) : remaining;
};
const isKeyboardSelectionEvent = event => {
  const space = [13, ' ', 'Spacebar'];
  const enter = [32, 'Enter'];
  const key = event && (event.key || event.which || event.keyCode) || '';
  if (!key || !space.concat(enter).includes(key)) {
    return false;
  }
  event.preventDefault();
  return true;
};
const value = location => location && location.address || location && location.gps && location.ready && 'Nykyinen sijainti' || '';
const getLocationType = location => location && location.gps === true ? 'position' : 'location';
const getSlackTimeOptions = t => {
  const timeOptions = [];
  for (let i = 0; i <= 9; i++) {
    const valueInMinutes = i * 10;
    timeOptions.push({
      displayName: `${valueInMinutes} ${t('minute-short')}`,
      value: valueInMinutes * 60
    });
  }
  return timeOptions;
};
process.env.NODE_ENV !== "production" ? ItinerarySearchControl.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  wide: PropTypes.bool
} : void 0;

/**
 * Panel that renders two DTAutosuggest search fields, including viapoint handling
 *
 * @example
 * const searchContext = {
 *   isPeliasLocationAware: false // true / false does Let Pelias suggest based on current user location
 *   minimalRegexp: undefined // used for testing min. regexp. For example: new RegExp('.{2,}'),
 *   lineRegexp: undefined //  identify searches for route numbers/labels: bus | train | metro. For example: new RegExp(
 *    //   '(^[0-9]+[a-z]?$|^[yuleapinkrtdz]$|(^m[12]?b?$))',
 *    //  'i',
 *    //  ),
 *   URL_PELIAS: '' // url for pelias searches
 *   feedIDs: ['HSL', 'HSLLautta'] // FeedId's like  [HSL, HSLLautta]
 *   geocodingSources: ['oa','osm','nlsfi']  // sources for geocoding
 *   geocodingSearchParams; {}  // Searchparmas fro geocoding
 *   getFavouriteLocations: () => ({}),    // Function that returns array of favourite locations.
 *   getFavouriteStops: () => ({}),        // Function that returns array of favourite stops.
 *   getLanguage: () => ({}),              // Function that returns current language.
 *   getFavouriteRoutes: () => ({}),       // Function that returns array of favourite routes.
 *   getPositions: () => ({}),             // Function that returns user's geolocation.
 *   getRoutesQuery: () => ({}),           // Function that returns query for fetching routes.
 *   getStopAndStationsQuery: () => ({}),  // Function that fetches favourite stops and stations from graphql API.
 *   getFavouriteRoutesQuery: () => ({}),  // Function that returns query for fetching favourite routes.
 *   getFavouriteVehicleRentalStations: () => ({}),  // Function that returns favourite bike rental station.
 *   getFavouriteVehicleRentalStationsQuery: () => ({}), // Function that returns query for fetching favourite bike rental stations.
 *   getHasOtpLocationFavourites: () => ({}), // Optional. Function that returns whether any OTP-backed favourite is currently available.
 *   startLocationWatch: () => ({}),       // Function that locates users geolocation.
 *   saveSearch: () => ({}),               // Function that saves search to old searches store.
 *   clearOldSearches: () => ({}),         // Function that clears old searches store.
 *   getFutureRoutes: () => ({}),          // Function that return future routes
 *   saveFutureRoute: () => ({}),          // Function that saves a future route
 *   clearFutureRoutes: () => ({}),        // Function that clears future routes
 * };
 *
 * const origin = {
 *  lat: 60.169196,
 *  lon: 24.957674,
 *  address: 'Aleksanterinkatu, Helsinki',
 *  set: true,
 *  ready: true,
 * }
 *
 * const destination = {
 *   lat: 60.199093,
 *   lon: 24.940536,
 *   address: 'Opastinsilta 6, Helsinki',
 *   set: true,
 *   ready: true,
 * }
 * onSelect(item, id) {
 *  return null;  // Define what to do when a suggestion is being selected. None by default.
 *  }
 * onClear(id) {
 *  return null;  // Define what to do when a suggestion is being selected. None by default.
 * }
 * const getAutoSuggestIcons: {
 *   // Called for every city bike station rendered as a search suggestion. Should return the icon and
 *   // color used for that station. Two icons are available, 'citybike-stop-digitransit' anditybike-stop-digitransit-secondary'.
 *   citybikes: station => {
 *      return ['citybike-stop-digitransit', '#f2b62d'];
 *   }
 * }
 * const targets = ['Locations', 'Stops', 'Routes']; // Defines what you are searching. all available options are Locations, Stops, Routes, VehicleRentalStations, FutureRoutes, MapPosition and CurrentPosition. Leave empty to search all targets.
 * const sources = ['Favourite', 'History', 'Datasource'] // Defines where you are searching. all available are: Favourite, History (previously searched searches), and Datasource. Leave empty to use all sources.
 * <DTAutosuggestPanel
 *    appElement={appElement} // Required. Root element's id. Needed for react-modal component.
 *    origin={origin} // Selected origin point
 *    destination={destination} // Selected destination point
 *    originPlaceHolder={'Give origin'} // Optional Give string shown initially inside origin search field
 *    destinationPlaceHolder={'Give destination'} // Optional Give string shown initally inside destination search field
 *    initialViaPoints={[]} // Optional.  If showViapointControl is set to true, pass initial via points to the panel. Currently no default implementation is given.
 *    updateViaPoints={() => return []} // Optional. If showViapointControl is set to true, define how to update your via point list with this function. Currenlty no default implementation is given.
 *    swapOrder={() => return null} // Optional. If showSwapControl is set to true, define how to swap order of your points (origin, destination, viapoints). Currently no default implementation is given.
 *    searchContext={searchContext}
 *    getAutoSuggestIcons={getAutoSuggestIcons}
 *    onSelect={this.onSelect}
 *    onClear={this.onClear}
 *    lang="fi" // Define language fi sv or en.
 *    addAnalyticsEvent={null} // Optional. you can record an analytics event if you wish. if passed, component will pass an category, action, name parameters to addAnalyticsEvent
 *    disableAutoFocus={false} // Optional. use this to disable autofocus completely from DTAutosuggestPanel
 *    sources={sources}
 *    targets={targets}
 *    isMobile  // Optional. Defaults to false. Whether to use mobile search.
 *    originMobileLabel="Origin label" // Optional. Custom label text for origin field on mobile.
 *    destinationMobileLabel="Destination label" // Optional. Custom label text for destination field on mobile.
 *    handleFocusChange={() => {}} // Optional. If defined overrides default onFocusChange behaviour
 *    showSwapControl={false} // Optional.
 *    showViapointControl={false} // Optional.
 */

const locationShape = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  address: PropTypes.string,
  lat: PropTypes.number,
  lon: PropTypes.number,
  locationSlack: PropTypes.number
}) : {};
const EMPTY_LIST = [];
const noop = () => {};
function DTAutosuggestPanel({
  appElement,
  origin,
  destination,
  originPlaceHolder = 'give-origin',
  destinationPlaceHolder = 'give-destination',
  viaPoints: viaPointsProp = null,
  updateViaPoints = noop,
  handleViaPointLocationSelected,
  swapOrder,
  searchPanelText,
  searchContext,
  onSelect,
  onClear,
  addAnalyticsEvent,
  lang,
  disableAutoFocus = false,
  sources = EMPTY_LIST,
  targets = EMPTY_LIST,
  filterResults,
  isMobile = false,
  originMobileLabel = null,
  destinationMobileLabel = null,
  refPoint,
  modeSet,
  colors = defaultColors,
  getAutoSuggestIcons,
  showScroll = false,
  onFocusChange,
  isEmbedded = false,
  showSwapControl = false,
  showViapointControl = false,
  showSlackControl = false
}) {
  const [t] = useTranslation('translation', {
    i18n
  });
  const [activeSlackInputs, setActiveSlackInputs] = useState([]);
  const [, forceUpdate] = useReducer(count => count + 1, 0);
  const destinationInputRef = useRef(null);
  // viaPoints is edited in place and the parent is notified afterwards, so a
  // missing prop needs an instance-local array instead of a shared default
  const fallbackViaPoints = useRef([]);
  const viaPoints = viaPointsProp || fallbackViaPoints.current;
  const {
    primary
  } = colors;
  const lng = lang;
  const storeDestinationRef = ref => {
    destinationInputRef.current = ref;
  };
  const handleFocusChange = () => {
    if (!destination || !destination.lat) {
      destinationInputRef.current.focus();
    }
  };
  const updateViaPointList = points => {
    if (points.length === 0) {
      updateViaPoints([]);
      return;
    }
    updateViaPoints(points.filter(vp => !isViaPointEmpty(vp)));
  };
  const handleToggleViaPointSlackClick = viaPointIndex => {
    setActiveSlackInputs(activeSlackInputs.includes(viaPointIndex) ? updateViaPointSlack(activeSlackInputs, viaPointIndex) : activeSlackInputs.concat([viaPointIndex]));
  };
  const handleViaPointSlackTimeSelected = (slackTimeInSeconds, i) => {
    if (addAnalyticsEvent) {
      addAnalyticsEvent({
        action: 'EditViaPointStopDuration',
        category: 'ItinerarySettings',
        name: slackTimeInSeconds / 60
      });
    }
    viaPoints[i].locationSlack = Number.parseInt(slackTimeInSeconds, 10);
    updateViaPointList(viaPoints);
  };
  const handleRemoveViaPointClick = viaPointIndex => {
    if (addAnalyticsEvent) {
      addAnalyticsEvent({
        action: 'RemoveJourneyViaPoint',
        category: 'ItinerarySettings',
        name: null
      });
    }
    viaPoints.splice(viaPointIndex, 1);
    setActiveSlackInputs(updateViaPointSlack(activeSlackInputs, viaPointIndex, true));
    updateViaPointList(viaPoints);
  };
  const handleAddViaPointClick = () => {
    if (addAnalyticsEvent) {
      addAnalyticsEvent({
        action: 'AddJourneyViaPoint',
        category: 'ItinerarySettings',
        name: 'QuickSettingsButton'
      });
    }
    viaPoints.push(getEmptyViaPointPlaceHolder());
    // re-render so that the placeholder shows up in the panel
    forceUpdate();
  };
  const handleDragEnd = event => {
    if (event.canceled) {
      return;
    }
    const {
      initialIndex,
      index
    } = event.operation.source?.sortable || {};
    if (initialIndex === undefined || initialIndex === index) {
      return;
    }
    const newViaPoints = [...viaPoints];
    const [moved] = newViaPoints.splice(initialIndex, 1);
    newViaPoints.splice(index, 0, moved);
    updateViaPoints(newViaPoints.filter(vp => !isViaPointEmpty(vp)));
  };
  const handleSwapOrderClick = () => {
    if (addAnalyticsEvent) {
      addAnalyticsEvent({
        action: 'SwitchJourneyStartAndEndPointOrder',
        category: 'ItinerarySettings',
        name: null
      });
    }
    viaPoints.reverse();
    swapOrder();
  };
  const getSlackDisplay = slackInSeconds => `${slackInSeconds / 60} ${t('minute-short', {
    lng
  })}`;
  const slackTime = getSlackTimeOptions(t);
  const getViaPointSlackTimeOrDefault = (viaPoint, defaultValue = 0) => viaPoint && viaPoint.locationSlack || defaultValue;
  const isViaPointSlackTimeInputActive = index => activeSlackInputs.includes(index);
  return /*#__PURE__*/jsxs("div", {
    className: cx(styles['autosuggest-panel'], isMobile && "small"),
    style: {
      '--color': primary
    },
    children: [' ', searchPanelText ? /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsxs("h1", {
        className: styles['autosuggest-searchpanel-text'],
        children: [' ', searchPanelText]
      })
    }) : null, /*#__PURE__*/jsxs("div", {
      className: styles['origin-input-container'],
      children: [/*#__PURE__*/jsx(DTAutoSuggest, {
        appElement: appElement,
        icon: "originEllipse",
        id: "origin",
        autoFocus: disableAutoFocus === true ? false : !isMobile && !origin?.lat,
        refPoint: refPoint,
        className: getLocationType(origin),
        placeholder: originPlaceHolder,
        value: value(origin),
        searchContext: searchContext,
        getAutoSuggestIcons: getAutoSuggestIcons,
        onSelect: onSelect,
        onClear: onClear,
        focusChange: onFocusChange || handleFocusChange,
        lang: lang,
        sources: sources,
        targets: targets,
        filterResults: filterResults,
        isMobile: isMobile,
        colors: colors,
        mobileLabel: originMobileLabel,
        modeSet: modeSet,
        showScroll: showScroll,
        isEmbedded: isEmbedded
      }), (showSwapControl || showViapointControl) && /*#__PURE__*/jsx(ItinerarySearchControl, {
        className: styles.opposite,
        enabled: showSwapControl,
        onClick: () => handleSwapOrderClick(),
        onKeyPress: e => isKeyboardSelectionEvent(e) && handleSwapOrderClick(),
        "aria-label": t('swap-order-button-label', {
          lng
        }),
        children: /*#__PURE__*/jsx(Icon, {
          img: "opposite",
          color: primary
        })
      })]
    }), viaPoints.length === 0 && /*#__PURE__*/jsx("div", {
      className: styles['rectangle-container'],
      children: /*#__PURE__*/jsx("div", {
        className: styles.rectangle
      })
    }), /*#__PURE__*/jsx(DragDropProvider, {
      onDragEnd: handleDragEnd,
      children: /*#__PURE__*/jsx("div", {
        className: styles['viapoints-container'],
        children: viaPoints.map((o, i) => /*#__PURE__*/jsx(SortableViaPoint, {
          id: `viapoint-${i}`,
          index: i,
          disabled: viaPoints.length <= 1,
          className: styles['viapoint-container'],
          children: handleRef => /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsxs("div", {
              className: styles['light-gray-background'],
              children: [/*#__PURE__*/jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/jsx("div", {
                  ref: handleRef,
                  className: styles['viapoint-before'],
                  style: viaPoints.length > 1 ? {
                    cursor: 'move'
                  } : {},
                  children: viaPoints.length > 1 && /*#__PURE__*/jsx(Icon, {
                    img: "ellipsis",
                    rotate: 90,
                    color: primary
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: `${styles['viapoint-input-container']} ${styles[`viapoint-${i + 1}`]}`,
                  children: /*#__PURE__*/jsx(DTAutoSuggest, {
                    appElement: appElement,
                    icon: "mapMarker",
                    id: "via-point",
                    ariaLabel: t('via-point-index', {
                      index: i + 1,
                      lng
                    }),
                    autoFocus: disableAutoFocus === true ? false : !isMobile,
                    placeholder: "via-point",
                    className: "viapoint",
                    searchContext: searchContext,
                    refPoint: refPoint,
                    value: o && o.address || '',
                    onSelect: onSelect,
                    onClear: onClear,
                    handleViaPoints: item => handleViaPointLocationSelected(item, i),
                    lang: lang,
                    sources: sources,
                    targets: targets,
                    filterResults: filterResults,
                    getAutoSuggestIcons: getAutoSuggestIcons,
                    isMobile: isMobile,
                    modeSet: modeSet,
                    colors: colors,
                    showScroll: showScroll
                  })
                }), showSlackControl && /*#__PURE__*/jsx(ItinerarySearchControl, {
                  className: styles['add-via-point-slack'],
                  enabled: showViapointControl,
                  onClick: () => handleToggleViaPointSlackClick(i),
                  onKeyPress: e => isKeyboardSelectionEvent(e) && handleToggleViaPointSlackClick(i),
                  "aria-label": t(isViaPointSlackTimeInputActive(i) ? 'add-via-duration-button-label-open' : 'add-via-duration-button-label-close', {
                    index: i + 1,
                    lng
                  }),
                  wide: true,
                  children: /*#__PURE__*/jsx(Icon, {
                    img: "time",
                    color: primary
                  })
                })]
              }), !isViaPointSlackTimeInputActive(i) && viaPoints[i] && viaPoints[i].locationSlack > 0 && /*#__PURE__*/jsx("span", {
                className: styles['viapoint-slack-time'],
                children: `${t('viapoint-slack-amount', {
                  lng
                })}: ${getSlackDisplay(viaPoints[i].locationSlack)}`
              }), /*#__PURE__*/jsx("div", {
                className: cx(styles['input-viapoint-slack-container'], !isViaPointSlackTimeInputActive(i) && "collapsed"),
                children: /*#__PURE__*/jsx("div", {
                  className: styles['select-wrapper'],
                  children: /*#__PURE__*/jsx(Select, {
                    id: `viapoint-slack-${i}`,
                    label: t('viapoint-slack-amount', {
                      lng
                    }),
                    options: slackTime,
                    value: getViaPointSlackTimeOrDefault(viaPoints[i]),
                    viaPointIndex: i,
                    icon: /*#__PURE__*/jsx("span", {
                      className: `${styles['combobox-icon']} ${styles['time-input-icon']}`,
                      children: /*#__PURE__*/jsx(Icon, {
                        img: "time",
                        color: primary
                      })
                    }),
                    onSlackTimeSelected: handleViaPointSlackTimeSelected
                  })
                })
              })]
            }), /*#__PURE__*/jsx(ItinerarySearchControl, {
              className: styles['remove-via-point'],
              enabled: showViapointControl,
              onClick: () => handleRemoveViaPointClick(i),
              onKeyPress: e => isKeyboardSelectionEvent(e) && handleRemoveViaPointClick(i),
              "aria-label": t('remove-via-button-label', {
                index: i + 1,
                lng
              }),
              children: /*#__PURE__*/jsx(Icon, {
                img: "trash",
                color: primary
              })
            })]
          })
        }, `viapoint-${i}`))
      })
    }), /*#__PURE__*/jsxs("div", {
      className: styles['destination-input-container'],
      children: [/*#__PURE__*/jsx(DTAutoSuggest, {
        appElement: appElement,
        icon: "mapMarker",
        id: "destination",
        autoFocus: disableAutoFocus === true ? false : !isMobile && !Number.isNaN(origin?.lat),
        storeRef: storeDestinationRef,
        placeholder: destinationPlaceHolder,
        className: getLocationType(destination),
        getAutoSuggestIcons: getAutoSuggestIcons,
        searchContext: searchContext,
        onSelect: onSelect,
        onClear: onClear,
        refPoint: refPoint,
        value: value(destination),
        lang: lang,
        sources: sources,
        targets: targets,
        filterResults: filterResults,
        isMobile: isMobile,
        mobileLabel: destinationMobileLabel,
        modeSet: modeSet,
        colors: colors,
        showScroll: showScroll,
        isEmbedded: isEmbedded
      }), (showSwapControl || showViapointControl) && /*#__PURE__*/jsx(ItinerarySearchControl, {
        className: cx(styles['add-via-point'], styles.more, viaPoints.length > 4 && "collapsed"),
        enabled: showViapointControl && viaPoints.length === 0,
        onClick: () => handleAddViaPointClick(),
        onKeyPress: e => isKeyboardSelectionEvent(e) && handleAddViaPointClick(),
        "aria-label": t('add-via-button-label', {
          lng
        }),
        children: /*#__PURE__*/jsx(Icon, {
          img: "viapoint",
          width: 1.25,
          height: 1.375,
          color: primary
        })
      })]
    })]
  });
}
process.env.NODE_ENV !== "production" ? DTAutosuggestPanel.propTypes = {
  appElement: PropTypes.string.isRequired,
  origin: locationShape,
  destination: locationShape,
  originPlaceHolder: PropTypes.string,
  destinationPlaceHolder: PropTypes.string,
  viaPoints: PropTypes.arrayOf(locationShape),
  updateViaPoints: PropTypes.func,
  handleViaPointLocationSelected: PropTypes.func,
  swapOrder: PropTypes.func,
  searchPanelText: PropTypes.string,
  searchContext: PropTypes.shape({
    URL_PELIAS: PropTypes.string
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  addAnalyticsEvent: PropTypes.func,
  lang: PropTypes.string.isRequired,
  disableAutoFocus: PropTypes.bool,
  sources: PropTypes.arrayOf(PropTypes.string),
  targets: PropTypes.arrayOf(PropTypes.string),
  filterResults: PropTypes.func,
  isMobile: PropTypes.bool,
  originMobileLabel: PropTypes.string,
  destinationMobileLabel: PropTypes.string,
  refPoint: locationShape,
  modeSet: PropTypes.string,
  colors: PropTypes.objectOf(PropTypes.string),
  getAutoSuggestIcons: PropTypes.objectOf(PropTypes.func),
  showScroll: PropTypes.bool,
  onFocusChange: PropTypes.func,
  isEmbedded: PropTypes.bool,
  showSwapControl: PropTypes.bool,
  showViapointControl: PropTypes.bool,
  showSlackControl: PropTypes.bool
} : void 0;

export { DTAutosuggestPanel as default, getEmptyViaPointPlaceHolder };
//# sourceMappingURL=index.js.map
